module.exports = __webpack_public_path__ + "static/media/foxnews.com_politics_elections_2016_events_elections-2016-live-blog_plot.86a721b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/foxnews.com_politics_elections_2016_events_elections-2016-live-blog_plot.png
// module id = 394
// module chunks = 0